import { render, staticRenderFns } from "./block-personal-injury-information.vue?vue&type=template&id=99950504&scoped=true&"
import script from "./block-personal-injury-information.vue?vue&type=script&lang=js&"
export * from "./block-personal-injury-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99950504",
  null
  
)

export default component.exports